export default "/profile/images/Creatio.svg?3bdb923bb4e811a882370a404e4a70d3";